import { Pipe, PipeTransform } from '@angular/core'

import { TableColumn } from '../components/table/table.component'

@Pipe({
  name: 'mergeColumns',
  standalone: true,
})
export class MergeColumnsPipe implements PipeTransform {
  public transform(
    firstArray: TableColumn[],
    secondArray: TableColumn[],
    remove: string[] = []
  ): TableColumn[] {
    if (!firstArray || !Array.isArray(firstArray)) {
      return secondArray || []
    }

    if (!secondArray || !Array.isArray(secondArray)) {
      return firstArray
    }

    // replace object with same key instead append object
    let newSecondArray = secondArray
    const newFirstArray = firstArray.map((first) => {
      const replace = secondArray.findIndex(
        (second) => second.key === first.key
      )
      if (replace !== -1) {
        newSecondArray = secondArray.toSpliced(replace, 1)
        return secondArray[replace]
      }
      return first
    })

    return [...newFirstArray, ...newSecondArray].filter(
      (col) => !remove.includes(col.key)
    )
  }
}
